import ReactSelect, { MultiValue } from 'react-select';
import { ITableColumn } from '../../types/layout/table';

interface ITableColumnsSelectorProps {
    allColumns: ITableColumn[];
    tableColumns: ITableColumn[];
    onChange: (e: MultiValue<{
        label: string;
        value: string;
    }>) => void;
}

function TableColumnsSelector({ allColumns, onChange, tableColumns }: ITableColumnsSelectorProps) {
    return (
        <div className="dropdown col">
            <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                Селектор колонок
            </button>
            <div className="dropdown-menu p-3">
                <label className="form-label">Выберите колонки</label>
                <ReactSelect
                    className="table-columns-selector"
                    options={allColumns.map((item) => ({ label: item.title, value: item.dataIndex }))}
                    isMulti
                    placeholder="Селектор колонок"
                    value={tableColumns.map((item) => ({ label: item.title, value: item.dataIndex }))}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}

export default TableColumnsSelector;
